<template>
  <div class="row container">
      <div class="col-md-6 col-12 mb-2">
          <px-select2
            idSelect="selectMil"
            :placeholder="'Seleccione ' + placeholder1"
            :options="data"
            @KuramaSelect="(selected = $event), (textoTitulo = selected.text)"
            @flagSelectSimple="flagSelectSimple = $event"
            :values="selected.id"
          ></px-select2>
          <!-- <pre>{{ selected }}</pre> -->
      </div>
      <div class="col-md-6 col-12">
          <px-select2
            :disable="!otroSelect"
            :values="selectedSeccion.id"
            idSelect="selectMil2"
            :placeholder="'Seleccione ' + placeholder2"
            :options="selected == ''? [] : (selected.seccion.map(function(e){ return {id: e.idContenido, text: e.titulo, fecha_actualizacion: e.fecha_actualizacion } }))"
            @KuramaSelect="(selectedSeccion = $event)"
            :valueSecondSelect="valSecondSelect"
          ></px-select2>
          <!-- <pre>{{ selectedSeccion }}</pre> -->
      </div>
  </div>
</template>
<script>
import PxSelect2 from '@/views/PxSelect.vue'

export default ({
name: 'selectFiltros2',
components: { PxSelect2 },
data() {
  return {
    selected: '',
    selectedSeccion: {id: null, values: '', text: '', fecha_actualizacion:'', seccion:  []},
    otroSelect: false,
    textoTitulo: '',
    flagSelectSimple: null,
    valSecondSelect: null,
  }
},
props:{
  data: null,
  placeholder1: '',
  placeholder2: '',
},
methods: {
    isEmpty(){ // esta funcion revisa si el objeto seleccionado esta completamente vacio. (solo trae text y id)
      let find = this.selected.seccion.length==0? true : false;
      // console.log(find);
      return find;
    },
    isLarge(){ // esta funcion recorre todos los objetos y verifica si la propiedad "seccion" esta llena en alguno de los items recorridos, si es true, entonces habilita el otro select
      let find = this.selected.seccion.length>0? true : false;
      // console.log('isLarge()', find);
      return find;
    },
},
watch:{
    selected(){
      if(this.flagSelectSimple){
        this.valSecondSelect = this.selected.text;
      }
      if(this.selected.seccion.length >0){
        let fecha_actualizacion_anio = this.selected.seccion[this.selected.seccion.length - 1].fecha_actualizacion; // obtengo la fecha del ultimo trimestre/tomo capturado para mostrarlo como la fecha mas actual del año en la vista padre
        this.$emit("fecha", fecha_actualizacion_anio)
      }
      this.otroSelect = this.isLarge();
      if(this.otroSelect == false) this.$emit("seleccionado", this.selected); //si solo hay info en 1 select. lo envia, y deshabilita el otro select
      else this.$emit("seleccionado", {select: '', selectedSeccion: {} }); // sino, limpia y espera q se seleccione algo del otro serlect
      this.$emit("titulo", this.textoTitulo);

      if(this.isEmpty()) this.$emit("seleccionado", {select: this.selected.text, fecha_actualizacion: this.selected.fecha_actualizacion, selectedSeccion: {} }); //si el 1er select no trae absolutamente nada

      this.selectedSeccion = {id: null, text: '', seccion:  []};

    },
    'selectedSeccion.text'(){ // manejo el 2do select
      let datos = {
        select: this.selected.text,
        selectedSeccion: this.selectedSeccion
      }
      if(this.selectedSeccion.text !='') this.$emit('seleccionado', datos);
      // console.log('envia 2:', this.selectedSeccion);
      this.$emit("titulo", `${this.textoTitulo} - ${this.selectedSeccion.text} `)
    },
    data(){
      if(this.data.length == 0){
        this.selectedSeccion.id = null;
        this.selected = {id: null, text: '', fecha_actualizacion: '', seccion: []}
      }
    }
}
})

/* ESTRUCTURA QUE RECIBE *********************************************************************************************
{
"id": 3,
"text": "12 Obligaciones Pagadas o Garantizadas con Fondos Federales",
"seccion": [
  {
    "idContenido": 8,
    "titulo": "2024",
    "pieTitulo": "",
    "descripcion": "",
    "link": "",
    "url_pdf": "",
    "url_word": "",
    "url_excel": "",
    "url_comprimido": "",
    "seccion": [
      {
        "idSeccion": 1,
        "titulo": "1er trimestre",
        "pieTitulo": "",
        "descripcion": "",
        "link": "",
        "url_pdf": "informacion-interes/armonizacion-contable/informacion/formatos-CONAC/DP/12-OP/2024/1er-Trimestre.pdf",
        "url_word": "",
        "url_excel": "informacion-interes/armonizacion-contable/informacion/formatos-CONAC/DP/12-OP/2024/1er-Trimestre.xls",
        "url_comprimido": ""
      }
    ]
  }
]
}
*/

</script>

